import store from "./shared/store";
import { fontsLoadingChecked } from "./shared/actions";

// Even if document.fonts.ready's promise fails
const contentShowTimeout = setTimeout(() => store.dispatch(fontsLoadingChecked()), 2800);
document.fonts.ready.then(() => {
  clearTimeout(contentShowTimeout);
  store.dispatch(fontsLoadingChecked());
});
